// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.texto, .corujito {
    width: 15vw; /* 10% da largura da janela de visualização */
}

.texto {
    position: absolute;
    bottom: 25%; /* Ajuste conforme necessário */
    right: 10%; /* Ajuste conforme necessário */
    z-index: 9000 !important;
}

.corujito {
    position: absolute;
    bottom: 1%; /* Ajuste conforme necessário */
    right: 1%; /* Ajuste conforme necessário */
    z-index: 9000 !important;
}

.texto-info {
    position: absolute;
    bottom: 1%; /* Ajuste conforme necessário */
    right: 30%; /* Ajuste conforme necessário */
    left: 3%; /* Ajuste conforme necessário */
    z-index: 9000 !important;
    font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/info-center/info-center.css"],"names":[],"mappings":"AAAA;IACI,WAAW,EAAE,6CAA6C;AAC9D;;AAEA;IACI,kBAAkB;IAClB,WAAW,EAAE,+BAA+B;IAC5C,UAAU,EAAE,+BAA+B;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU,EAAE,+BAA+B;IAC3C,SAAS,EAAE,+BAA+B;IAC1C,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU,EAAE,+BAA+B;IAC3C,UAAU,EAAE,+BAA+B;IAC3C,QAAQ,EAAE,+BAA+B;IACzC,wBAAwB;IACxB,eAAe;AACnB","sourcesContent":[".texto, .corujito {\n    width: 15vw; /* 10% da largura da janela de visualização */\n}\n\n.texto {\n    position: absolute;\n    bottom: 25%; /* Ajuste conforme necessário */\n    right: 10%; /* Ajuste conforme necessário */\n    z-index: 9000 !important;\n}\n\n.corujito {\n    position: absolute;\n    bottom: 1%; /* Ajuste conforme necessário */\n    right: 1%; /* Ajuste conforme necessário */\n    z-index: 9000 !important;\n}\n\n.texto-info {\n    position: absolute;\n    bottom: 1%; /* Ajuste conforme necessário */\n    right: 30%; /* Ajuste conforme necessário */\n    left: 3%; /* Ajuste conforme necessário */\n    z-index: 9000 !important;\n    font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
